export enum ROUTES {
	DEFAULT_ROUTE = '/',
	DASHBOARD = '/dashboard',
	INVESTMENT = '/investment/:dealId/:mipId/:investmentWorkflowId',
	HELP_PAGE = '/help',
	AUTH = '/auth',
	PAGE_NOT_FOUND = '/404',
	SIGNED_REDIRECT = '/signed-redirect',
	PROFILE = '/profile',
	DOCUMENTS = '/documents/deal/:dealId/mip/:mipId/investor/:investorId',
	VALUATIONS = '/valuations/:investorId',
	VALUATIONS_AS_DASHBOARD = '/dashboard/:investorId?',
	TRANSACTIONS_BY_INVESTOR_ID = '/transactions/:investorId',
	TRANSACTIONS = '/transactions',
	GENERIC_ERROR = '/error',
	TERMS = '/terms',
	PRIVACY = '/privacy',
	EID_EASY_FTN_CALLBACK = '/eid-easy/ftn-callback',
	EID_EASY_OTP_CALLBACK = '/eid-easy/otp-callback',
	PUBLIC_SIGNING = '/public-signing',
	STANDALONE_KYC = '/deal/:dealId/mip/:mipId/kyc/:kycWorkflowId',
}

export enum AUTH_ROUTES {
	LOGIN = '/login',
	REGISTER = '/register',
	CHANGE_EMAIL = '/change-email',
	CANCEL_EMAIL_CHANGE = '/cancel-email-change',
	INVITATION_EXPIRED = '/invitation-expired',
}

export enum LEGACY_AUTH_ROUTES {
	RESET_PASSWORD = '/reset-password',
	ACCEPT_INVITE = '/accept-invitation',
}

export const DEFAULT_GUEST_ROUTE = `${ROUTES.AUTH}${AUTH_ROUTES.LOGIN}`;

export const DEFAULT_PROTECTED_ROUTE = ROUTES.DASHBOARD;
